<script lang="ts">
  import Sun from "lucide-svelte/icons/sun";
  import Moon from "lucide-svelte/icons/moon";
  import Monitor from "lucide-svelte/icons/monitor";
  import { theme } from "$lib/stores/theme.svelte";
  import { userPrefs } from "$lib/stores/userPrefs.svelte";
  import * as m from "$lib/paraglide/messages";
  import { cn } from "$lib/utils/cn";

  type Props = { class?: string };
  const { class: className }: Props = $props();

  const label = $derived(
    theme.preference === "dark"
      ? m.theme_cycle_to_system()
      : theme.preference === "light"
        ? m.theme_cycle_to_dark()
        : m.theme_cycle_to_light(),
  );
</script>

<button
  type="button"
  class={cn(
    "inline-flex size-9 items-center justify-center rounded-md border border-(--surface-border)",
    "bg-(--surface-bg-elev) text-(--surface-fg) hover:bg-(--surface-bg-sunken)",
    "transition-colors duration-fast ease-standard",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--surface-ring)",
    className,
  )}
  aria-label={label}
  title={label}
  onclick={() => userPrefs.cycleTheme()}
>
  {#if theme.preference === "dark"}
    <Moon class="size-4" aria-hidden="true" />
  {:else if theme.preference === "light"}
    <Sun class="size-4" aria-hidden="true" />
  {:else}
    <Monitor class="size-4" aria-hidden="true" />
  {/if}
</button>
